/**
 * Dynamically set assets' CDN path.
 *
 */

// eslint-disable-next-line no-undef
__webpack_public_path__ = `${window.whStatic.config.fragmentCdnHost}${window.whStatic.config.fragmentCdnPath}`;
